import { render, staticRenderFns } from "./TabSwitchContainer.vue?vue&type=template&id=2dbbcabc&scoped=true"
import script from "./TabSwitchContainer.vue?vue&type=script&lang=js"
export * from "./TabSwitchContainer.vue?vue&type=script&lang=js"
import style0 from "./TabSwitchContainer.vue?vue&type=style&index=0&id=2dbbcabc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbbcabc",
  null
  
)

export default component.exports